import { render, staticRenderFns } from "./CartsList.vue?vue&type=template&id=24522496"
import script from "./CartsList.vue?vue&type=script&lang=js"
export * from "./CartsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports